import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {IHomeWorkStatistic} from "./useGetHomeWorksStatistics";

export type THomeWorkStatisticsByTheme = Record<string, IHomeWorkStatistic>;

interface IFilter {
    projectId?: string,
    teacherId?: string,
    groupId?: string
}

export const useGetHomeWorksStatisticsByThemes = (request: IFilter, t?: number, disabled?: boolean) => {
    const [resp, setResp] = useState<THomeWorkStatisticsByTheme | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!request?.projectId || !request?.teacherId || disabled) return;

        setIsLoading(true)
        const req = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWorksStatisticsByThemes')
            .get()
            .addQuery('moduleProjectId', request?.projectId)
            .addQuery('teacherId', request?.teacherId)

        if (request?.groupId) req.addQuery('groupId', request.groupId)

        req.send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [request?.projectId, request?.teacherId, request?.groupId, t, disabled])

    return {statisticsByThemes: resp, isLoading, error};
}
import {API, Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {IHomeWorkStatistic} from "./useGetHomeWorksStatistics";

export type THomeWorkStatisticsByTheme = Record<string, IHomeWorkStatistic>;

interface IFilter {
    projectId?: string,
    teacherId?: string,
    groupId?: string
}

export const useGetHomeWorksStatisticsByThemes = (request: IFilter, t?: number, disabled?: boolean) => {
    const [resp, setResp] = useState<THomeWorkStatisticsByTheme | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!request?.projectId || !request?.teacherId || disabled) return;

        setIsLoading(true)
        const req = API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWorksStatisticsByThemes')
            .get()
            .addQuery('moduleProjectId', request?.projectId)
            .addQuery('teacherId', request?.teacherId)

        if (request?.groupId) req.addQuery('groupId', request.groupId)

        req.send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [request?.projectId, request?.teacherId, request?.groupId, t, disabled])

    return {statisticsByThemes: resp, isLoading, error};
}
